import { UserModel } from "@/model/user/userModel";

export function ConvertToUserModel(userInfo: any): UserModel {
  /* eslint-disable @typescript-eslint/camelcase */
  const userModel: UserModel = {
    userId: userInfo.id,
    displayName: userInfo.given_name,
    lastLogInDateTime: userInfo.lastLogInDateTime,
    registerDateTime: userInfo.registerDateTime,
    phone: userInfo.phone_number,
    pictureUrl: userInfo.picture,
    signatureUrl: userInfo.signatureUrl,
    userEmail: userInfo.userEmail,
  };

  return userModel;
}

export const ConvertToUserDetailList = (userDetailRawList: any) => {
  const userDetailList = [];
  if (userDetailRawList && userDetailRawList.length > 0) {
    for (const userDetailRaw of userDetailRawList) {
      userDetailList.push({
        userId: userDetailRaw.userId,
        userEmail: userDetailRaw.userEmail,
        userType: userDetailRaw.userType,
        signatureUrl: userDetailRaw.signatureUrl,
        displayName: userDetailRaw.displayName,
        accountingFirmId: userDetailRaw.accountingFirmId,
        phone: userDetailRaw.phone,
        pictureUrl: userDetailRaw.pictureUrl,
        userName: userDetailRaw.userName,
      });
    }
  }
  return userDetailList;
};
